// extracted by mini-css-extract-plugin
export default {"addCardModal":"AddCard_addCardModal__i6j+O","closeModal":"AddCard_closeModal__4NVHP","header":"AddCard_header__4peif"};